import {
  GET_SETTINGS,
  GET_SETTINGS_FAIL,
  GET_SETTINGS_SUCCESS,
  GET_TYPE_SETTINGS,
} from "./actionTypes"

export const getSettings = payload => ({
  type: GET_SETTINGS,
  payload: payload || {},
})

export const getSettingsSuccess = payload => ({
  type: GET_SETTINGS_SUCCESS,
  payload: payload,
})

export const getSettingsFail = error => ({
  type: GET_SETTINGS_FAIL,
  payload: error,
})

export const setTypeSettings = payload => ({
  type: GET_TYPE_SETTINGS,
  payload: payload,
})